// src/context/GuestContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';

const GuestContext = createContext();

export const useGuest = () => useContext(GuestContext);

export const GuestProvider = ({ children }) => {
  const [isGuest, setIsGuest] = useState(false);
  const [guestToken, setGuestToken] = useState(null);

  useEffect(() => {
    // Verificar si hay un token de invitado en localStorage
    const storedGuestToken = localStorage.getItem('guestToken');
    const storedIsGuest = localStorage.getItem('isGuest') === 'true';
    
    if (storedIsGuest && storedGuestToken) {
      setIsGuest(true);
      setGuestToken(storedGuestToken);
    }
  }, []);

  const loginAsGuest = () => {
    const newGuestToken = `guest_${Math.random().toString(36).substring(2, 15)}`;
    localStorage.setItem('guestToken', newGuestToken);
    localStorage.setItem('isGuest', 'true');
    setIsGuest(true);
    setGuestToken(newGuestToken);
    return newGuestToken;
  };

  const clearGuestSession = () => {
    localStorage.removeItem('guestToken');
    localStorage.removeItem('isGuest');
    setIsGuest(false);
    setGuestToken(null);
  };

  return (
    <GuestContext.Provider value={{ isGuest, guestToken, loginAsGuest, clearGuestSession }}>
      {children}
    </GuestContext.Provider>
  );
};
